import React from 'react';
import './About.css';

const About = () => {
    return (
        <div className="about-page">
            <div className="container">
                <header className="page-header">
                    <h1>About Takumi Tension</h1>
                </header>

                <section className="about-content">
                    <div className="about-text">
                        <div className="story-section">
                            <h2>Our Story</h2>
                            <p>Welcome to Takumi Tension, your trusted partner for professional racquet stringing services. We embody the Japanese spirit of craftsmanship, delivering precision stringing that elevates your game to new heights.</p>

                            <p>Our journey began with a simple mission: to help players achieve their best performance through precision stringing and expert equipment knowledge. We understand that every player is unique, and so are their stringing needs.</p>
                        </div>

                        <div className="mission-section">
                            <h2>Our Mission</h2>
                            <p>At Takumi Tension, our expertise lies in understanding the unique needs of each player and providing personalized stringing solutions that enhance performance and comfort. With master-level craftsmanship and attention to detail, we ensure every racquet is strung to perfection.</p>
                        </div>

                        <div className="values-section">
                            <h2>Our Values</h2>
                            <div className="values-grid">
                                <div className="value-item">
                                    <h3>Precision</h3>
                                    <p>Every string job is completed with meticulous attention to detail</p>
                                </div>
                                <div className="value-item">
                                    <h3>Expertise</h3>
                                    <p>Master-level craftsmanship and years of professional experience</p>
                                </div>
                                <div className="value-item">
                                    <h3>Service</h3>
                                    <p>Personalized recommendations tailored to your playing style</p>
                                </div>
                                <div className="value-item">
                                    <h3>Quality</h3>
                                    <p>Only premium strings and materials from trusted brands</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="about-image">
                        <div className="image-placeholder">
                            <img src="/images/shop-interior-home.jpg" alt="takumi" width="100%" height="100%" />
                        </div>
                    </div>
                </section>

                <section className="certification-section">
                    <h2>Professional Certification</h2>
                    <div className="certification-content">
                        <div className="cert-info">
                            <h3>Master Craftsmanship</h3>
                            <p>We embrace the Japanese philosophy of Takumi - the relentless pursuit of perfection in our craft, ensuring that every string job meets the highest professional standards in the industry.</p>
                        </div>
                        <div className="cert-benefits">
                            <h4>What This Means for You:</h4>
                            <ul>
                                <li>Professional-grade stringing techniques</li>
                                <li>Up-to-date knowledge of latest string technologies</li>
                                <li>Consistent, reliable service quality</li>
                                <li>Expert advice on string selection and tension</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="location-section">
                    <div className="location-content">
                        <h2>Visit Our Shop</h2>
                        <div className="location-details">
                            <div className="address">
                                <h3>Location</h3>
                                <p>60 Eu Tong Sen St, #01-17 Furama City Center, Singapore 059804</p>
                            </div>
                            <div className="hours">
                                <h3>Hours</h3>
                                <ul>
                                    <li><s>Monday - Friday: 9:00 AM - 7:00 PM</s></li>
                                    <li><s>Saturday: 9:00 AM - 5:00 PM</s></li>
                                    <li><s>Sunday: Closed</s></li>
                                </ul>
                                <p className="hours-note">We recommend calling ahead before your visit to confirm availability — we occasionally operate outside regular hours, including late nights.</p>
                            </div>
                        </div>
                        <div className="location-description">
                            <p>Our shop is conveniently located in the heart of the sports district, making it easy for players to drop off and pick up their racquets. We welcome walk-ins and are always happy to discuss your stringing needs.</p>
                        </div>
                    </div>
                </section>

                <section className="contact-cta">
                    <div className="cta-content">
                        <h2>Ready to Experience Professional Stringing?</h2>
                        <p>Contact us today to learn more about our services or to schedule your racquet stringing.</p>
                        <a href="/contact" className="cta-button">
                            Get in Touch
                        </a>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default About;
